'use client';
import { useMemo } from 'react';
import { isString } from '@s7/utils';
import { client } from '../client.js';
import { useMutation } from '../../../../common/client/useMutation.js';
import { compileTemplate } from '../../../../common/compileTemplate/compileTemplate.js';

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var SubscriptionResponse = /*#__PURE__*/ function() {
    function SubscriptionResponse() {}
    SubscriptionResponse.isNotValid = function isNotValid(data) {
        return data.errors.some(function(error) {
            return error.id.split("/").includes("email_format");
        });
    };
    SubscriptionResponse.isAlreadySubscribed = function isAlreadySubscribed(data) {
        return data.errors.some(function(error) {
            return error.id === "member_exists";
        });
    };
    return SubscriptionResponse;
}();
var useSubscriptionMutation = function(options, handlers) {
    var url = options.url, lang = options.lang, dto = _object_without_properties_loose(options, [
        "url",
        "lang"
    ]);
    var requestUrl = useMemo(function() {
        return isString(url) ? compileTemplate(url, {
            lang: lang
        }) : "";
    }, [
        url,
        lang
    ]);
    return useMutation(function() {
        return client.post({
            url: requestUrl,
            body: dto
        });
    }, handlers);
};

export { SubscriptionResponse, useSubscriptionMutation };
